var React = require('react');

function I (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15 26.25C21.2132 26.25 26.25 21.2132 26.25 15C26.25 8.7868 21.2132 3.75 15 3.75C8.7868 3.75 3.75 8.7868 3.75 15C3.75 21.2132 8.7868 26.25 15 26.25Z","stroke":"#1F1F1F","strokeWidth":"2.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M14.0625 14.5312H15V20.625H15.9375","stroke":"#1F1F1F","strokeWidth":"2.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M14.7656 11.7188C15.8012 11.7188 16.6406 10.8793 16.6406 9.84375C16.6406 8.80822 15.8012 7.96875 14.7656 7.96875C13.7301 7.96875 12.8906 8.80822 12.8906 9.84375C12.8906 10.8793 13.7301 11.7188 14.7656 11.7188Z","fill":"#1F1F1F","key":2})]);
}

I.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = I;

I.default = I;
